import React from "react";
import injectSheet from "react-jss";
import PropTypes from "prop-types";
import Calendar from "react-calendar/dist/entry.nostyle";

const styles = ({ theme }) => ({
  root: {
    backgroundColor: theme.colors.white,
    "& .react-calendar__month-view__weekNumbers": {
      "& .react-calendar__tile": {
        color: theme.colors.senary1,
        fontWeight: theme.fontWeights.normal,
        "&:focus, &:not([disabled]):hover": {
          backgroundColor: "inherit",
          cursor: "default"
        }
      }
    },
    "& .react-calendar__tile, & .react-calendar__navigation__label, & .react-calendar__navigation__next-button, & .react-calendar__navigation__next2-button, & .react-calendar__navigation__prev-button, & .react-calendar__navigation__prev2-button ": {
      borderRadius: theme.borderRadius.default,
      padding: theme.padding[1],
      fontFamily: theme.fonts.serif,
      border: "none",
      color: theme.colors.black,
      fontWeight: theme.fontWeights.semibold,
      backgroundColor: theme.colors.white,
      fontSize: theme.textSizes.base,
      margin: "0px !important",
      transition: "all 0.1s ease-in-out",
      "&:focus, &:not([disabled]):hover": {
        backgroundColor: theme.colors.senary4,
        outline: "none",
        cursor: "pointer"
      },
      "&:disabled": {
        color: theme.colors.senary3
      }
    },
    "& .react-calendar__navigation__next-button, & .react-calendar__navigation__prev-button": {
      padding: [theme.padding[2], theme.padding.sm],
      color: theme.colors.primary2,
      fontSize: `${theme.textSizes.copy} !important`,
      fontWeight: theme.fontWeights.bold
    },
    "& .react-calendar__tile--active": {
      color: theme.colors.primary1,
      backgroundColor: `${theme.colors.primary4} !important`,
      fontWeight: theme.fontWeights.bold
    },
    "& .react-calendar__month-view__days__day--neighboringMonth": {
      color: theme.colors.senary2,
      fontWeight: theme.fontWeights.normal
    },
    "& .react-calendar__month-view__weekdays__weekday": {
      fontWeight: theme.fontWeights.bold,
      textAlign: "center",
      padding: theme.padding[1],
      "& abbr": {
        textDecoration: "none",
        fontFamily: theme.fonts.serif,
        fontSize: theme.textSizes.sm
      }
    }
  }
});

const CalendarView = React.memo(function CalendarView({
  classes,
  minDate,
  maxDate,
  ...rest
}) {
  let props = rest;

  if (minDate) {
    props = { ...props, minDate: new Date(minDate) };
  }

  if (maxDate) {
    props = { ...props, maxDate: new Date(maxDate) };
  }

  return (
    <div className={classes.root}>
      <Calendar className={classes.calendar} {...props} />
    </div>
  );
});

CalendarView.defaultProps = {
  prevLabel: "←",
  nextLabel: "→",
  next2Label: null,
  prev2Label: null,
  locale: "sv",
  maxDetail: "month",
  minDetail: "year",
  showWeekNumbers: true
};

CalendarView.propTypes = {
  /** Unfortunately does not allow the Icon component, deafutls to asci arrow */
  prevLabel: PropTypes.string,
  /** Unfortunately does not allow the Icon component, deafutls to asci arrow */
  nextLabel: PropTypes.string,
  locale: PropTypes.string,
  maxDetail: PropTypes.string,
  minDetail: PropTypes.string,
  showWeekNumbers: PropTypes.bool,
  /** Limit the possibility to select dates before this date */
  minDate: PropTypes.string,
  /** Limit the possibility to select dates after this date */
  maxDate: PropTypes.string
};

export default injectSheet(styles, { inject: ["classes"] })(CalendarView);
